import React from 'react';

import { QueryClientProvider } from '@tanstack/react-query';
import PropTypes from 'prop-types';
import queryClient from 'react-query-settings/queryClient';

import AppWrapper from 'components/apps/AppWrapper';
import { ProjectsAnalyticsDashboardContext } from 'components/contexts/ProjectsAnalyticsDashboardContext';
import ProjectsAnalyticsDashboard from 'components/projectsAnalytics/components/ProjectsAnalyticsDashboard';

import { sendAnalytics } from 'components/helpers/analytics';
import { resourceShape } from 'components/helpers/serialisableResources';

export default function EntryPoint({ contextProps, wrappedProps }) {
  const {
    account: {
      attributes: { name: accountName },
      id: accountId,
    },
    user: currentUser,
  } = contextProps.actors;

  return (
    <QueryClientProvider client={queryClient}>
      <AppWrapper {...contextProps}>
        <ProjectsAnalyticsDashboardContext.Provider
          value={{
            ...wrappedProps,
            sendAnalytics: (analyticTrackingId, args) =>
              sendAnalytics(analyticTrackingId, {
                ...args,
                accountId,
                accountName,
                currentUser,
              }),
          }}
        >
          <ProjectsAnalyticsDashboard />
        </ProjectsAnalyticsDashboardContext.Provider>
      </AppWrapper>
    </QueryClientProvider>
  );
}

EntryPoint.propTypes = {
  wrappedProps: PropTypes.shape({
    domainDashboardConfigurableFields: PropTypes.shape({
      data: PropTypes.arrayOf(resourceShape('field')),
    }).isRequired,
    isApprovalsEnabled: PropTypes.bool.isRequired,
    isDigitalSignaturesEnabled: PropTypes.bool.isRequired,
    isFoldersEnabled: PropTypes.bool.isRequired,
    isProjectReviewDatesEnabled: PropTypes.bool.isRequired,
    isRiskRegisterEnabled: PropTypes.bool.isRequired,
    seedFilterSelectionConfiguration: PropTypes.shape({
      data: resourceShape('filterSelectionConfiguration'),
      included: PropTypes.array.isRequired,
      meta: PropTypes.shape({
        isBulkUpdateInProgress: PropTypes.bool.isRequired,
      }).isRequired,
    }).isRequired,
  }),
};
